'use client';

import { useEffect } from 'react';

import { useSearchParams } from 'next/navigation';

import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';

export function useShopDropSignupComplete(sellerId?: number) {
  const searchParams = useSearchParams();
  const { sendActivityTrackerEvent } = useActivityTracker();

  const isSignupComplete =
    searchParams.get('signupComplete') === 'true' && sellerId;

  useEffect(() => {
    if (isSignupComplete) {
      sendActivityTrackerEvent(
        ActivityTrackerEventType.SHOP_DROP_SIGNUP_COMPLETE_ACTION,
        {
          sellerId,
          variant: VARIANT_IDENTIFIER,
          schemaVersion: '1.0',
        }
      );
      const url = new URL(window.location.href);
      url.searchParams.delete('signupComplete');
      window.history.replaceState(null, '', url.pathname + url.search);
    }
  }, [isSignupComplete]);
}
